import { render, staticRenderFns } from "./ModalEditReceipt.vue?vue&type=template&id=b255450a&"
import script from "./ModalEditReceipt.vue?vue&type=script&lang=js&"
export * from "./ModalEditReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditReceipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports